import React from "react";
import DataGrid, { HeaderFilter, Column } from "devextreme-react/ui/data-grid";
// import ReactDOM from "react-dom";
// import NoDataComponent from "../../../../../Shared/noDataImage";
import validaciones from "../../../../../../helpers/validaciones";
import moment from "moment";

class AtencionesMedicas extends React.PureComponent {
  render() {
    return (
      <DataGrid
        showBorders={false}
        showColumnLines={false}
        showRowLines={false}
        rowAlternationEnabled
        className="custom-table height-min cursor-disabled color"
        noDataText=""
        dataSource={this.props.data}
        onContentReady={(e) => {
          if (e.component.totalCount() === 0) {
            const config = {};
            config.addClass = "table-margin";
            const noDataSpan = e.component.element().querySelector(".dx-datagrid-nodata");
            const element = validaciones.noDataDOMElement(config, "Sin atenciones médicas");
            noDataSpan.appendChild(element);
          }
        }}
      >
        <HeaderFilter visible texts={{ cancel: "Cancelar", emptyValue: "Sin resultados", ok: "Aceptar" }} />
        <Column
          dataField="EstadoAtencion"
          caption="Estado Atención"
          cellComponent={(row) => (
            <React.Fragment >
              {row.data.EstadoAtencion == null ?
                "S/D"
                :
                row.data.EstadoAtencion
              }
            </React.Fragment>
          )}
        />
        <Column
          dataField="TipoAtencionMedica"
          caption="Tipo Atención Médica"
          cellComponent={(row) => (
            <React.Fragment >
              {row.data.TipoAtencionMedica == null ?
                "S/D"
                :
                validaciones.accentValidator(row.data.TipoAtencionMedica)
              }
            </React.Fragment>
          )}
        />
        <Column
          dataField="FechaAtencion"
          caption="Fecha Atención"
          sortIndex={0}
          sortOrder="asc"
          sortingMethod={(v1, v2) => {
            const v1d = moment(v1, "DD/MM/YYYY");
            const v2d = moment(v2, "DD/MM/YYYY");
            if (v1d.isAfter(v2d)) return -1;
            if (v1d.isSame(v2d)) return 0;
            if (v1d.isBefore(v2d)) return 1;
            return 0;
          }}
          calculateCellValue={(data) => `${data.FechaAtencion ? moment(data.FechaAtencion).format("DD/MM/YYYY") : "S/D"}`}
          format="dd/MM/yyyy"
        />
        <Column
          dataField="LugarAtencion"
          caption="Lugar Atención"
          cellRender={(props) => (
            <div className="div-transporte-atenciones" title={props.data.LugarAtencion}>
              <span>{props.data.LugarAtencion}</span>
              {props.data.Transporte && <i className="material-icons transporte">directions_car</i>}
            </div>
          )}
        />
        <Column
          dataField="HoraAtencion"
          caption="Hora"
          allowFiltering={false}
        />
      </DataGrid>
    );
  }
}

export default AtencionesMedicas;
